import PrimaryCtaType from '~/constants/PrimaryCtaType';

type Params = {
  ctaType: PrimaryCtaType;
  isInExclusivePreview: boolean;
  isOutOfArea: boolean;
  isReservedByOtherAndSubscribed: boolean;
  isReservedByUserAndKicked: boolean;
  isSold: boolean;
  purchasePending: boolean;
  stopSaleRecall: boolean;
};

export default function deriveVehicleDescription({
  ctaType,
  isInExclusivePreview,
  isOutOfArea,
  isReservedByOtherAndSubscribed,
  isReservedByUserAndKicked,
  isSold,
  purchasePending,
  stopSaleRecall
}: Params): string | undefined {
  if (isSold) return 'This vehicle has been sold and is no longer available';
  if (stopSaleRecall)
    return 'Sale of this vehicle is temporarily paused due to a safety recall';
  if (isOutOfArea)
    return "This vehicle cannot be delivered to the customer's location";

  switch (ctaType) {
    case PrimaryCtaType.GetStarted:
      return 'Vehicle is available and the customer can begin purchasing';
    case PrimaryCtaType.DisabledGetStarted:
      return "Vehicle exists but cannot be purchased in the customer's delivery area";
    case PrimaryCtaType.ContinuePurchase:
      return isInExclusivePreview
        ? 'This vehicle is in a private preview period and not yet publicly available for purchase'
        : 'The customer is currently in the process of purchasing this vehicle and can continue where they left off';
    case PrimaryCtaType.CancelPreOrder:
      return 'The customer has reserved this vehicle which is still being prepared for sale';
    case PrimaryCtaType.Reservable:
      return 'This vehicle is not yet ready for sale but the customer can reserve priority to purchase it when available';
    case PrimaryCtaType.DisabledPreOrder:
      return 'This vehicle is not yet ready for sale and pre-order reservations are not currently available';
    case PrimaryCtaType.GetAlerts:
      return 'Another customer has reserved this vehicle — it is not available but the customer can sign up for alerts';
    case PrimaryCtaType.ViewSimilarVehicles:
      if (isReservedByUserAndKicked)
        return 'The customer previously reserved this vehicle but their reservation was cancelled';
      if (purchasePending)
        return 'Another customer is actively in the process of purchasing this vehicle — it is not available';
      if (isReservedByOtherAndSubscribed)
        return 'Another customer has reserved this vehicle — the customer has already signed up for availability alerts';

      return 'This vehicle is not currently available to purchase';
    case PrimaryCtaType.Default:
    case PrimaryCtaType.NotifyMe:
    case PrimaryCtaType.Reservation:
      return undefined;
    default: {
      const ignored: never = ctaType;

      return undefined;
    }
  }
}
